import { useAuth } from "@/context/AuthContext";
import { Eye, LogOut } from "lucide-react";

export default function ImpersonationBanner() {
  const { isImpersonating, exitImpersonation, user } = useAuth();
  if (!isImpersonating) return null;

  return (
    <div className="bg-amber-400 text-zinc-900 px-4 py-2 flex items-center justify-between text-sm font-medium z-50">
      <div className="flex items-center gap-2">
        <Eye className="w-4 h-4 shrink-0" />
        <span>
          Modalità impersonazione — stai visualizzando come{" "}
          <strong>{user?.name || user?.email || "utente"}</strong>
        </span>
      </div>
      <button
        onClick={exitImpersonation}
        className="flex items-center gap-1.5 bg-zinc-900/10 hover:bg-zinc-900/20 px-3 py-1 rounded text-xs font-semibold transition-colors whitespace-nowrap ml-4"
      >
        <LogOut className="w-3.5 h-3.5" />
        Esci dall'impersonazione
      </button>
    </div>
  );
}
